'use strict'

import { Draw as DoubleClickZoom } from 'ol/interaction'
import { transformExtent } from 'ol/proj'
import availableInteractions from '@/components/interaction-button/availableInteractions.json'
import Config from '@/config.js'

import MapStoreMixin from '@/mixins/store/map'
import LayerStoreMixin from '@/mixins/store/layer'

import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'

let getDefaultInteractionConfiguration = (key) => {
  return availableInteractions.find((ic) => ic.key === key)
}

const ZOOM_INCREMENT = 1

export default {
  mixins: [
    MapStoreMixin,
    LayerStoreMixin
  ],
  components: {
    Keypress: () => import('vue-keypress')
  },
  computed: {
    interactionButtons () {
      let toReturn = []
      let found
      let defaultInteractionConfiguration
      this.currentShownLayers.forEach((layer) => {
        layer.webviewConfig.availableInteractions.forEach((interaction) => {
          found = toReturn.find((i) => i.key === interaction.key)
          defaultInteractionConfiguration = getDefaultInteractionConfiguration(interaction.key)
          if (typeof found === 'undefined' && typeof defaultInteractionConfiguration !== 'undefined') toReturn.push(defaultInteractionConfiguration)
        })
      })

      return toReturn
    },
    ...mapState({
      vectorClickInteraction: state => state.interaction.vectorClickInteraction,
      elevationProfilInteraction: state => state.interaction.elevationProfilInteraction
    }),
    ...mapGetters([
      'interactions'
    ])
  },
  methods: {
    enableDoubleClick () {
      let dblClickInteraction = this.mapRef.$map.getInteractions().getArray().find((i) => { return i instanceof DoubleClickZoom })
      if (typeof dblClickInteraction !== 'undefined') this.mapRef.$map.addInteraction(new DoubleClickZoom())
    },
    disableDoubleClick () {
      let dblClickInteraction = this.mapRef.$map.getInteractions().getArray().find((i) => { return i instanceof DoubleClickZoom })
      this.mapRef.$map.removeInteraction(dblClickInteraction)
    },
    zoomIn () {
      this.mapView.animate({
        zoom: this.mapView.getZoom() + ZOOM_INCREMENT,
        duration: 500
      })
    },
    zoomOut () {
      this.mapView.animate({
        zoom: this.mapView.getZoom() - ZOOM_INCREMENT,
        duration: 500
      })
    },
    centerToExtent () {
      this.centerTo(Config.mapConfiguration.center)
    },
    centerTo (coordinates, _zoom = Config.mapConfiguration.view.zoom) {
      let zoom = _zoom === null ? this.mapView.getZoom() : _zoom
      this.mapView.animate({
        center: coordinates,
        zoom: zoom,
        duration: 1000
      })
    },
    zoomToExtent (bbox, transform = true) {
      if (transform) {
        bbox = transformExtent(bbox, 'EPSG:21781', 'EPSG:2056')
      }

      this.mapView.fit(bbox, {
        duration: 1000
      })
    },
    ...mapActions([
      'initInteractions'
    ]),
    ...mapMutations([
      'initElevationProfilInteraction'
    ])
  }
}
